import { segregateApiResponse } from "./segregationUtils";
import { sortFilterMessages, sortModalConfig } from "./sortingUtils";
import { mergeWithState } from "./mergingUtils";

export function handleApiResponse(
  responseMessages: any[],
  isMobile: boolean,
  existingState: any,
  otherConfigs?: any
): any {
  const { sortMsg = true } = otherConfigs || {};
  const { messages, modalConfig } = segregateApiResponse(
    responseMessages,
    isMobile
  );
  const sortedFilteredMessages = sortFilterMessages(
    messages,
    isMobile,
    sortMsg
  );
  const sortedModalConfig = sortModalConfig(modalConfig, isMobile);

  return mergeWithState(
    existingState.messages,
    sortedFilteredMessages,
    existingState.modalConfig,
    sortedModalConfig
  );
}
